import React, { PureComponent } from 'react';
import { NormalizedSeries } from 'types';
import { getSeriesValue } from './utils';
// Components
import styles from './chart.scss';
interface ChartLabelsProps {
  series: NormalizedSeries[];
  width: number;
  height: number;
}

const odd = (s, index) => index % 2 === 1;
const even = (s, index) => index % 2 === 0;
export default class ChartLabels extends PureComponent<ChartLabelsProps> {
  renderSeriesLabel(s, index) {
    return (
      <tspan key={index} style={{ fill: s.color }}>
        {index > 0 && ' '}
        {getSeriesValue(s, 1 - this)}
      </tspan>
    );
  }

  render() {
    const { series, width, height, children } = this.props;
    const lines = [];
    const labels = [];
    const hLineCount = Math.floor(height / 60);
    for (let i = 0; i <= hLineCount; i++) {
      const percent = i / hLineCount;
      const y = percent * height;
      lines.push(<line key={i} x1={0} x2={width} y1={y} y2={y} className={styles.seriesLine} />);
      labels.push(
        <text
          key={i}
          fill={series.color}
          className={styles.seriesLabel}
          y={y}
          x={3}
          textAnchor="start"
        >
          {series.filter(even).map(this.renderSeriesLabel, percent)}
        </text>
      );

      labels.push(
        <text
          key={i + 1000}
          className={styles.seriesLabel}
          y={y}
          x={width - 3}
          textAnchor="end"
        >
          {series.filter(odd).map(this.renderSeriesLabel, percent)}
        </text>
      );
    }


    return (
      <>
        {lines}
        {children}
        {labels}
      </>
    );
  }
}
